module.exports = __webpack_public_path__ + "img/300x600_layout_3.92c959fd.svg";